"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VendorsManagement = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var TableMaker_1 = __importDefault(require("containers/TableMaker"));
var tableConf_1 = __importDefault(require("./tableConf"));
var Table = (0, TableMaker_1.default)(tableConf_1.default);
var VendorsManagement = function () { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Recharge Vendors" }), (0, jsx_runtime_1.jsx)(Table, {})] })); };
exports.VendorsManagement = VendorsManagement;
exports.default = exports.VendorsManagement;
